import { Controller } from "@hotwired/stimulus"
import { RATES } from "../site/rates.js"
import { freightEstimate } from "../site/estimate.js"

// Shows the range the public website would give for these miles and vehicle,
// using the website's own pricing files, so the dispatcher can see it beside
// the firm rate they are typing. It never fills the rate in.
export default class extends Controller {
  static targets = ["miles", "vehicle", "rate", "output"]

  connect() {
    this.update()
  }

  update() {
    const miles = parseInt(this.milesTarget.value, 10)
    if (!miles || miles < 1) {
      this.outputTarget.textContent = "Enter the miles to see the website's range."
      return
    }

    const vehicle = this.vehicleTarget.value
    const estimate = freightEstimate({ miles, vehicle, fullLoad: vehicle === "semi", pallets: 1, lbs: 1 }, RATES)
    if (!estimate || estimate.tooBig) {
      this.outputTarget.textContent = ""
      return
    }

    const money = (amount) => amount.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
    let text = `Website range for ${miles.toLocaleString("en-US")} miles: ${money(estimate.low)} to ${money(estimate.high)}, before extras.`

    const rate = parseFloat(String(this.rateTarget.value).replace(/[$,\s]/g, ""))
    if (rate > 0) text += ` Your rate is $${(rate / miles).toFixed(2)} a mile.`

    this.outputTarget.textContent = text
  }
}
